import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { WhatsAppMessageTemplate } from "./types";

export const getWhatsAppMessageTemplates = reactQueryFetcherAdapter(
  cacheKey,
  async (signal, messagingServiceId: string): Promise<WhatsAppMessageTemplate[]> => {
    return await fetch(
      `/engagement/whatsapp/message_templates/${messagingServiceId}`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
